import React, { useState } from "react";
import { Stack, Radio, RadioGroup, FormControlLabel } from "@mui/material";
import Tasks from "./Tasks";
import Complain from "./Complain";

const ComplainTask = () => {
  const [selectedOption, setSelectedOption] = useState("complain"); // Default to "complain"

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div>
      <Stack spacing={4} marginX={4} mt={1}>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={8}
        >
          <RadioGroup
            row
            aria-label="options"
            name="options"
            value={selectedOption}
            onChange={handleChange}
          >
            <FormControlLabel
              value="complain"
              control={<Radio />}
              label="Complain"
            />
            <FormControlLabel value="tasks" control={<Radio />} label="Tasks" />
          </RadioGroup>
        </Stack>

        {selectedOption === "complain" && <Complain />}
        {selectedOption === "tasks" && <Tasks />}
      </Stack>
    </div>
  );
};

export default ComplainTask;
